<page-body fxFlexFill>
	<loading></loading>
</page-body>
